<template>
  <a-modal
    title="Applied Rules"
    :visible="visible"
    :destroy-on-close="true"
    :body-style="{ maxHeight: '60vh', overflowY: 'auto' }"
    width="600px"
    @cancel="closeModal"
  >
    <p v-if="reviewAssociate" class="font-bold" data-testid="applied-rules-associate">
      {{ associate.first_name }} {{ associate.last_name }} (ID: {{ associate.associate_number }})
    </p>
    <profile-auth
      :authorizations.sync="authorizations"
      :suggested-auth-type="suggestedAuthType"
      :is-disabled="loading"
    />
    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button :disabled="loading" @click="closeModal">Close</a-button>
        <a-button
          @click="save"
          type="primary"
          :loading="loading"
          :disabled="!hasChanges"
          >Save</a-button
        >
      </div>
    </template></a-modal
  >
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ProfileAuthorizations from './profile-authorizations.vue'
import { notification } from 'ant-design-vue'

const { mapActions: profileActions, mapState: profileState } = createNamespacedHelpers('profile')
export default {
  components: {
    'profile-auth': ProfileAuthorizations
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    reviewAssociate: {
      type: Object,
      default: null
    },
    suggestedAuthType: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      authorizations: [],

      loading: false
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) this.authorizations = [...this.availableAuthTypes]
      },
      immediate: true
    }
  },
  computed: {
    ...profileState({
      profileAssociate: state => state.associate
    }),
    associate() {
      return this.reviewAssociate || this.profileAssociate
    },
    availableAuthTypes() {
      return Array.isArray(this.associate?.available_auth_types) ? this.associate.available_auth_types : []
    },
    hasChanges() {
      return (
        this.authorizations.length !== this.availableAuthTypes.length ||
        this.authorizations.some(type => !this.availableAuthTypes.includes(type))
      )
    }
  },
  methods: {
    ...profileActions(['updateAssociate', 'setAssociate']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    closeModal() {
      if (this.loading) return
      this.$emit('update:visible', false)
    },

    async save() {
      if (this.loading || !this.hasChanges) return
      this.loading = true

      const payload = {
        associate: {
          ...this.associate,
          available_auth_types: this.authorizations
        }
      }

      try {
        const data = await this.updateAssociate(payload)

        this.showNotification('success', 'Info', 'Applied rules have been edited successfully')

        const updatedAssociate = { ...this.associate, ...data }
        if (this.reviewAssociate) this.$emit('update:reviewAssociate', updatedAssociate)
        if (this.profileAssociate?.id === updatedAssociate.id) this.setAssociate(updatedAssociate)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
